export default "__VITE_ASSET__Bf9yFO4a__"